import React from 'react';
import {
    Button,
    Dialog,
    DialogActions,
    DialogContent,
    DialogTitle,
    IconButton
} from '@mui/material';
import { Close } from '@mui/icons-material';
import { Breakpoint, styled } from '@mui/material/styles';

interface ModalDialogProps {
    title: string;
    children?: React.ReactNode;
    maxWidth?: false | Breakpoint | undefined;
    open: boolean;
    setOpen: (open: boolean) => void;
    hasConfirm?: boolean;
    onConfirm: () => void;
}

const StyledDialog = styled(Dialog)(({ theme }) => ({
    '& .MuiDialogContent-root': {
        padding: theme.spacing(2)
    },
    '& .MuiDialogActions-root': {
        padding: theme.spacing(2)
    },
    minWidth: '320px'
}));

export const ModalDialog: React.FC<ModalDialogProps> = (
    props: ModalDialogProps
) => {
    const {
        title,
        children,
        maxWidth = 'md',
        open,
        setOpen,
        hasConfirm = false,
        onConfirm
    } = props;

    return (
        <StyledDialog
            fullWidth={true}
            maxWidth={maxWidth}
            open={open}
            onClose={() => setOpen(false)}
            aria-labelledby='dialog-title'
            aria-describedby='dialog-content'
        >
            <DialogTitle sx={{ m: 0, p: 2 }} id='dialog-title'>
                {title}
            </DialogTitle>
            <IconButton
                aria-label='close'
                onClick={() => setOpen(false)}
                sx={{
                    position: 'absolute',
                    right: 8,
                    top: 8,
                    color: (theme) => theme.palette.grey[500]
                }}
            >
                <Close />
            </IconButton>
            <DialogContent id='dialog-content' sx={{ fontWeight: 'medium' }}>
                {children}
            </DialogContent>
            <DialogActions>
                <Button variant='outlined' onClick={() => setOpen(false)}>
                    Voltar
                </Button>
                {hasConfirm && (
                    <Button
                        variant='contained'
                        color='success'
                        onClick={() => {
                            setOpen(false);
                            onConfirm();
                        }}
                    >
                        Confirmar
                    </Button>
                )}
            </DialogActions>
        </StyledDialog>
    );
};
